import styled from 'styled-components/macro';
import { TBody, Td, Th, Tr } from '../../shared/Table';
import { colourGreen10 } from '../../styling/colours';
import { ManifoldDiagramTable } from './manifold-diagram/ManifoldDiagramWithTable';
import { PdfPumpResponse } from './PdfDataResponse';

type Props = {
  pumps: Array<PdfPumpResponse> | null;
};

export const PumpTable = ({ pumps }: Props) => {
  return pumps?.length ? (
    <div>
      <h2>Circulation Pumps</h2>
      <CirculationPumpTable>
        <TBody>
          {pumps &&
            pumps.map(({ partId, displayName, description }) => (
              <Tr key={partId}>
                <PumpTableHeader scope="row">{displayName}</PumpTableHeader>
                <Td>{description}</Td>
              </Tr>
            ))}
        </TBody>
      </CirculationPumpTable>
    </div>
  ) : null;
};

const PumpTableHeader = styled(Th)`
  width: 100px;
  background-color: ${colourGreen10};
`;

const CirculationPumpTable = styled(ManifoldDiagramTable)`
  width: 100%;
`;
